// API for Deposit data (displayed in Deposit tab)
import { API_BASE_URL, getUserDepartment } from "./base";
import { withCsrfHeaders, fetchWithCsrfRetry } from "./csrf";

// Helper function to get user department and create headers
const getApiHeaders = () => {
  const userDepartment = getUserDepartment();

  return {
    "Content-Type": "application/json",
    "X-User-Department": userDepartment,
  };
};

// Get deposit records by account number
export const apiGetDepositByNoAkaun = async (noAkaun) => {
  try {
    const response = await fetch(`${API_BASE_URL}/deposit/noakaun/${encodeURIComponent(noAkaun)}`, {
      method: "GET",
  headers: getApiHeaders(),
      credentials: "include",
      cache: "no-store",
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching deposit by account number:", error);
    throw error;
  }
};

// Create new deposit record (Tambah Deposit)
export const apiCreateDeposit = async (depositData) => {
  try {
  const response = await fetchWithCsrfRetry(`${API_BASE_URL}/deposit`, {
      method: "POST",
  headers: await withCsrfHeaders(getApiHeaders()),
      body: JSON.stringify(depositData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating deposit:", error);
    throw error;
  }
};

// Update deposit record
export const apiUpdateDeposit = async (id, depositData) => {
  try {
  const response = await fetchWithCsrfRetry(`${API_BASE_URL}/deposit/${id}`, {
      method: "PUT",
  headers: await withCsrfHeaders(getApiHeaders()),
      body: JSON.stringify(depositData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating deposit:", error);
    throw error;
  }
};

// Delete deposit record
export const apiDeleteDeposit = async (id) => {
  try {
  const response = await fetchWithCsrfRetry(`${API_BASE_URL}/deposit/${id}`, {
      method: "DELETE",
  headers: await withCsrfHeaders(getApiHeaders()),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting deposit:", error);
    throw error;
  }
};

// Fallback function that returns empty data structure
export const apiGetDepositFallback = async () => {
  console.warn("Using fallback data for deposit");
  return {
    data: [],
    total: 0,
  };
};

// ================================
// INBOIS API FUNCTIONS
// ================================

// Get inbois records by account number
export const apiGetInboisByNoAkaun = async (noAkaun) => {
  try {
    const response = await fetch(`${API_BASE_URL}/inbois/akaun/${encodeURIComponent(noAkaun)}`, {
      method: "GET",
  headers: getApiHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching inbois by account number:", error);
    throw error;
  }
};

// Delete inbois record
export const apiDeleteInbois = async (id) => {
  try {
  const response = await fetchWithCsrfRetry(`${API_BASE_URL}/inbois/${id}`, {
      method: "DELETE",
  headers: await withCsrfHeaders(getApiHeaders()),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting inbois:", error);
    throw error;
  }
};
